import { PresaleData } from "../../../../types/Presale";
import { PRESALE_CONTRACT_ADDRESS } from "../../../constants";
import { checkIfObjectIsUndefined } from "../../../helpers";
import { Presale } from "../../../classes/presale-manager/Presale";
import { presaleAbi } from "../../../abis/presaleAbi";
import { useReadContract } from "wagmi";

export function usePresale(presaleId: bigint) {
  const { data, error, isLoading } = useReadContract({
    address: PRESALE_CONTRACT_ADDRESS,
    abi: presaleAbi,
    functionName: "presale",
    args: [presaleId],
  });

  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  const parsedData = {
    saleToken: data?.[0],
    startTime: data?.[1],
    endTime: data?.[2],
    price: data?.[3],
    tokensToSell: data?.[4],
    baseDecimals: data?.[5],
    inSale: data?.[6],
    vestingStartTime: data?.[7],
    vestingCliff: data?.[8],
    vestingPeriod: data?.[9],
    enableBuyWithEth: data?.[10],
    enableBuyWithUsdt: data?.[11],
  } as PresaleData;

  const isDataUndefined = checkIfObjectIsUndefined(parsedData);

  if (isDataUndefined) return;

  const presale = new Presale(parsedData);
  

  return { data: presale };
}
